module.exports = __webpack_public_path__ + "aef22b61c886ec69454f0171817167ac.png";